import { text } from '@fortawesome/fontawesome-svg-core';
import { Skeleton } from '@mui/material';
import { useParams, useNavigate } from 'react-router-dom';
import { Urls } from '../../context';
import { MilestoneStatusResponses, MilestoneTypes } from '../../models';
import { PlatformRootUrl } from '../../utils/platform';
import { CerebroLink } from '../CerebroLink';
import { CerebroText } from '../CerebroText';
import { MilestoneIcon } from './MilestoneIcon';

interface MilestoneStatusItemProps {
	display: string;
	isFetching: boolean;
	size: number;
	type: MilestoneTypes;
	inProgress: boolean;
	response?: MilestoneStatusResponses;
}

export const MilestoneStatusItem: React.FC<MilestoneStatusItemProps> = ({
	display,
	isFetching,
	size,
	type,
	inProgress,
	response,
}) => {
	const { guid } = useParams<'guid'>();
	const navigate = useNavigate();

	const goToTermSheetsPage = () => {
		navigate(`/${guid}/${Urls.TermSheets.Root}`);
	};

	const gotoDocumentsPage = () => {
		navigate(`/${guid}/${Urls.Documents.Root}`);
	};

	const gotoCallSchedulingPage = () => {
		navigate(`/${guid}/${Urls.Calls.Root}`);
	};

	return (
		<>
			{type == 'DocumentsDownloaded' && (
				<CerebroLink
					sx={{ paddingBottom: '5px', display: 'block', cursor: 'pointer' }}
					onClick={() => gotoDocumentsPage()}
				>
					{display}
				</CerebroLink>
			)}

			{type == 'ReadyForCall' && (
				<CerebroLink
					sx={{ paddingBottom: '5px', display: 'block', cursor: 'pointer' }}
					onClick={() => gotoCallSchedulingPage()}
				>
					{display}
				</CerebroLink>
			)}

			{type == 'TermSheetSubmitted' && (
				<CerebroLink
					sx={{ paddingBottom: '5px', display: 'block', cursor: 'pointer' }}
					onClick={() => goToTermSheetsPage()}
				>
					{display}
				</CerebroLink>
			)}

			{type != 'DocumentsDownloaded' && type != 'ReadyForCall' && type != 'TermSheetSubmitted' && (
				<CerebroText variant="small" gutterBottom align="center" weight="medium">
					{display}
				</CerebroText>
			)}

			{isFetching ? (
				<Skeleton animation="wave" sx={theme => ({ backgroundColor: theme.palette.primary.light })} />
			) : (
				<MilestoneIcon size={size} type={type} inProgress={inProgress} response={response} />
			)}
		</>
	);
};
